/**
import { cueData } from './mock'
 *
 * Created Date: 2019-03-09, 18:28:50 (zhenliang.sun)
 * Last Modified: 2019-10-21, 17:22:50 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export const cueData = {
  usrdata: [],
  cuepoint: []
};
